export const isFullUrl = (str: string) => {
  // eslint-disable-next-line prefer-named-capture-group, sonarjs/slow-regex, sonarjs/regex-complexity, regexp/no-unused-capturing-group, regexp/no-dupe-disjunctions, regexp/no-super-linear-backtracking -- This is a simplified regex for URL validation
  const regex = /^(ht{2}ps?:\/{2})([\d.a-z-]+|(?:\d+\.){3}\d+)(:\d+)?([\w./-]*)(\?.*)?\/?$/;
  return regex.test(str);
};
